import { render, staticRenderFns } from "./SelectResource.vue?vue&type=template&id=538880f4"
import script from "./SelectResource.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectResource.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports